<template>
  <div>
    <v-flex lg12>
      <CriarMensagem @postar="postar" tammaximo="700" v-if="user" />
    </v-flex>
    <v-flex lg12>
      <Mensagem :mensagens="mensagens" />
    </v-flex>
  </div>
</template>

<script>
import Mensagem from "@/components/Mensagem.vue";
import CriarMensagem from "@/components/CriarMensagem.vue";
import { mapGetters } from "vuex";

export default {
  data: () => ({}),
  mounted() {
    //this.$store.dispatch('anuncio/carregarMensagens', this.anuncio);
  },
  methods: {
    postar(p) {
      // console.log(p.texto);
      if (p.texto !== "") {
        this.$store.dispatch("anuncio/postarMensagem", {
          anuncio: this.anuncio,
          bsgStrPergunta: p.texto,
          clientePergunta: this.user
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "cliente/user",
      mensagens: "anuncio/mensagens"
    })
  },
  props: ["anuncio"],
  components: {
    CriarMensagem,
    Mensagem
  }
};
</script>

<style></style>
